 import * as angular from 'angular';
 import AppConstants from '../gorillaboy/AppConstants';
 import {IModalScope} from "../types/angular-types";

 interface IScope extends IModalScope {
    formData : {
        folderName: string,
        searchUserName: string
    }
    assigneeName: string;
}

 angular.module('GorillaBoy')
 .controller('TransferModalCtrl', [
     '$scope',
     '$rootScope',
     '$q',
     '$log',
     '$translate',
     '$uibModalInstance',
     'authenticatedUser',
     'TasksService',
     'TypeaheadService',
     'MessageManager',
     'MessageProvider',
     'SignalProvider',
     'resourcesToTransfer',
     function transferModalCtrl($scope: IScope, $rootScope, $q, $log, $translate, $uibModalInstance, authenticatedUser, TasksService, TypeaheadService, MessageManager, MessageProvider, SignalProvider, resourcesToTransfer) {
         $scope.formData = {
             folderName: '',
             searchUserName: ''
         };
         $scope.assigneeId = '';

         $scope.resourcesToTransfer =resourcesToTransfer;
         var transferByNotOwnerErrorMessage = 'the owner of transfer ownership task should also be the owner of related resource',
             duplicateTransferTaskErrorMessage = 'one resource can only have one transfer ownership task';
 
         function successCreateTaskAssignment(response) {
             $log.info("Task has success created and assigned");
             MessageManager.addSuccessMessage(MessageProvider.defaultTaskCreationSuccess);
             $uibModalInstance.dismiss();
         }
         function errorCreateTaskAssignment(response) {
             MessageManager.addErrorMessage(MessageProvider.defaultTaskAssignmentFailure);
             $log.info("Task succeed create but assignment fail");
         }
         function successCreateTask(response) {
             $log.info("assign task " + response.Task + " to " + $scope.assigneeId);
             TasksService.createTaskAssignment(response.Task.Id, $scope.assigneeId, 'USER')
                 .then(successCreateTaskAssignment, errorCreateTaskAssignment);
         }
         function errorCreateTask(response) {
             if (response && response.exceptionMessage && response.exceptionMessage.Message && response.exceptionMessage.Message.includes(transferByNotOwnerErrorMessage)) {
                MessageManager.addErrorMessage(MessageProvider.transferTaskCreatedWithoutResourceOwnerPermissionFailure);
             } else if (response && response.exceptionMessage && response.exceptionMessage.Message && response.exceptionMessage.Message.includes(duplicateTransferTaskErrorMessage)) {
                MessageManager.addErrorMessage(MessageProvider.transferTaskCreatedWithDuplicateTaskFailure);
             } else {
                MessageManager.addErrorMessage(MessageProvider.defaultTaskCreationFailure);
             }
             $log.error("Task creation has failed" + JSON.stringify(response));
         }
 
         // call from clicking create folder button in the title bar of file list view
         $scope.createTask = function() {
             angular.forEach($scope.resourcesToTransfer, function(resId, i) {
                  TasksService.createTask(resId.name, null, resId.id, AppConstants.TASKDEF_IDS.TRANSFER_RESOURCE_OWNERSHIP)
                 .then(successCreateTask, errorCreateTask);
             });
         };
 
         $scope.hideModal = function() {
             $uibModalInstance.dismiss();
         };

         $scope.transferButtonEnabled = function() {
             return !!$scope.assigneeId;
         };
 
         $scope.typeAheadSelect = function(item) {
            $log.debug("typeAheadSelect called" + item.metadata.Id);
            $scope.assigneeId = item.metadata.Id;

            if ($scope.assigneeId) {
                $scope.assigneeName = $scope.getFullName(item.metadata);
            } else {
                $scope.assigneeName = '';
            }

            if ($scope.formData.searchUserName) {
                $scope.formData.searchUserName = '';
            }
         };
 
         $scope.searchUsers = function(query) {
             var deferred = $q.defer(),
                 searchUsersParams = {
                     excludeSelf: true,
                     reuseLastSearchOnError: true,
                     showQueryAsMatch: false
                 };
 
             TypeaheadService.searchUsers(query, searchUsersParams).then(
                 function resolveSuccess(userCollaboratorWrappers) {
                     deferred.resolve(userCollaboratorWrappers);
                 },
                 function resolveFailure() {
                     deferred.resolve([]);
                 });

             return deferred.promise;
         };
 
     }
 ]);